import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import styles from './DarkOverlay.module.scss';

export type DarkOverlayProps = {
    show: boolean;
};

export const DarkOverlay = ({ show }: DarkOverlayProps): JSX.Element | null => {
    const [portalElement, setPortalElement] = useState<HTMLDivElement | null>(
        null,
    );

    useEffect(() => {
        const element =
            document.querySelector<HTMLDivElement>('#portal-header-flyout') ??
            document.createElement('div');
        element.id = 'portal-header-flyout';
        document.body.appendChild(element);
        setPortalElement(element);

        return () => {
            // Cleanup function to remove portal on unmount
            if (element) {
                document.body.removeChild(element);
            }
        };
    }, []);

    if (!portalElement) return null;

    return createPortal(
        <div
            data-zta="shop-header-dark-overlay"
            data-show={show}
            className={classNames(styles.darkOverlay, {
                [styles.darkOverlayShow]: show,
            })}
        />,
        portalElement,
    );
};
